<closeable-dialog class="tcdd-train-dialog-container">
  <div dialog-card-header class="dialog-header">
    <div class="info-group">
      <span class="column-info title">
      {{ isCoupling ? ('leaderTrainNo' | translate) : ('tcddTrainNumber' | translate) }} :
      </span>
      <span class="column-info content">{{ trainNo }}</span> &nbsp;
    </div>
    <div *ngIf="isCoupling" class="info-group">
      <span class="column-info title">{{ 'followerTrainNo' | translate }} : </span>
      <span class="column-info content">{{ secondTrainNo }}</span> &nbsp;
    </div>
    <div *ngIf="isDataLoaded" class="badge train-badge-common-style train-status-badge-style" [ngClass]="'train-badge-' + trainStatus">
      {{ 'train-badge-' + trainStatus | translate }}
    </div>
  </div>

  <div dialog-card-body class="dialog-body full-height">
    <!-- Main Tabset -->
    <nb-tabset class="main-nb-tabset" (changeTab)="onMainTabChange($event)">
      <!-- Main Tabs -->
      <nb-tab
        *ngFor="let mainTab of mainTabs; let mainIndex = index"
        [tabIcon]="mainTabsError[mainIndex] === 1 ? {icon: 'warning-icon.png', pack: 'uruk', options: {color: '#FF1F00', class: 'nb-tab-custom-icon'}} : null"
        [tabTitle]="mainTab.title | translate"
        [active]="activeMainTab === mainTab.id"
        [tabId]="mainTab.id">

        <div *ngIf="activeMainTab === TcddMainSystem.PROGNOSTIC_SYSTEM">
          <ng-container *ngTemplateOutlet="listTemplate; context: {}"></ng-container>
        </div>

        <!-- Sub Tabset -->
        <nb-tabset *ngIf="activeMainTab === TcddMainSystem.DIAGNOSTIC_SYSTEM && mainTab.subTabs?.length > 0"
                   class="sub-nb-tabset" (changeTab)="onTabChange($event)">
          <!-- Sub Tabs -->
          <nb-tab
            *ngFor="let subTab of mainTab.subTabs"
            [tabIcon]="getSubTabWarningIcon(mainIndex, subTab.id)"
            [tabTitle]="subTab.title | translate"
            [active]="activeSubTab === subTab.id"
            [tabId]="subTab.id">

            <div class="tab-content-wrapper">
              <!-- Shared SVG Image Container -->
              <div class="main-svg-container" [ngClass]="{ 'full-height': isFullHeight }">
                <div [id]="'backContainer_' + subTab.id" class="back-container" (click)="goBack()">
                  <i class="fa fa-angle-left"></i>
                  <span class="back-text">{{ 'back' | translate }}</span>
                </div>

                <i [id]="'prevIcon_' + subTab.id"
                   class="fas fa-chevron-left fa-2x prev-icon"
                   [ngClass]="getPrevIconClass()"
                   (click)="loadPrevSvg()"></i>

                <i [id]="'nextIcon_' + subTab.id"
                   class="fas fa-chevron-right fa-2x next-icon"
                   [ngClass]="getNextIconClass()"
                   (click)="loadNextSvg()"></i>

                <div *ngIf="showImageTitleContainer" class="image-title-container">
                  <p class="image-title-text">
                    {{ getWagonTitle() | translate }} - {{ pathInfo.pathTitle | translate }}
                  </p>
                </div>

                <!-- 2D Button (only in 3D view) -->
                <div *ngIf="is2DVisible" class="btn-2d-container">
                  <button (click)="open2DViewer()" [title]="('2D View' | translate)">
                    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M21 21.4457V33M21 21.4457L31 14.8629V26.9486L21 33M21 21.4457L11 14.8629V26.9486L21 33M11 14.88L21 9L31 14.88"
                        stroke="#D1D1D1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <rect x="3" y="3" width="36" height="36" rx="1" stroke="#D1D1D1" stroke-width="2"/>
                    </svg>
                  </button>
                </div>

                <!-- 3D Button (only in 2D view) -->
                <div *ngIf="is3DVisible" class="btn-3d-container">
                  <button (click)="open3DViewer()" [title]="('3D View' | translate)">
                    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M21 21.4457V24.9943M21 21.4457L23.8333 19.6629M21 21.4457L18.1667 19.6629M11 14.8629V18.0857M14.0833 13.0114L11 14.88L14.0833 16.7143M11 26.9486V23.4M11 26.9486L14.0833 29.0057M11 26.9486L14.0833 25.1829M31 26.9486V23.4M31 26.9486L27.9167 29.0057M31 26.9486L27.9167 25.1829M31 14.8629V18.0857M27.9167 13.2857L31 14.88L27.9167 16.7657M21 33V29.2629M21 33L23.8333 31.2857M21 33L18.1667 31.2857M21 9V12.7371M21 9L23.8333 10.7143M21 9L18.1667 10.7143"
                        stroke="#D1D1D1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M40 21C40 10.5066 31.4934 2 21 2L24 5M2 21C2 31.4934 10.5066 40 21 40L18 37"
                            stroke="#D1D1D1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>

                <div class="svg-container" [id]="'svgContainer_' + subTab.id"></div>
                <div *ngIf="isCoupling" class="svg-container" [id]="'svgContainerPassive_' + subTab.id"></div>

                <div
                  *ngIf="currentView === TcddDialogView.UNIT_3D || currentView === TcddDialogView.UNIT_3D_DETAIL"
                  class="model-viewer-container"
                  [id]="'modelViewerContainer_' + subTab.id">

                  <model-viewer
                    class="model-viewer"
                    [src]="pathInfo.path_3D"
                    [alt]="pathInfo.pathTitle"
                    auto-rotate
                    camera-controls
                    touch-action="pan-x pan-y pinch-zoom"
                    (load)="onModelLoad()"
                    (error)="onModelError($event)"
                    (progress)="onProgress($event)">
                  </model-viewer>

                  <div class="custom-progress" *ngIf="progress < 1">
                    <div class="bar" [style.width.%]="progress * 100"></div>
                  </div>
                </div>

                <div *ngIf="currentView !== TcddDialogView.UNIT_VISUAL && currentView !== TcddDialogView.UNIT_3D" class="status-bar">
                  <!-- Temperature -->
                  <div *ngIf="activeSubTab === TcddSubSystem.AIR_CONDITION_SYSTEM" class="temperature-display">
                    <span class="temperature-label">{{ 'outsideAirTemperature' | translate }}</span>
                    <img src="assets/images/train/temperature.svg" alt="temperature" class="temperature-icon">
                    <span class="temperature-value">{{ outsideAirTemperature }}°C</span>
                  </div>

                  <!-- Interior Lighting Info-->
                  <div *ngIf="activeSubTab === TcddSubSystem.OTHER_SYSTEM && currentView === TcddDialogView.TRAIN_OVERVIEW" class="interior-lighting-info">
                    <div class="toggle-icon-container" (click)="toggleInteriorLightingStatuses()">
                      <img class="toggle-icon" src="assets/images/info-icon.svg" alt="Interior Lighting Information Icon" />
                    </div>

                    <div class="lighting-status-dropdown" *ngIf="interiorLightingInfoVisibility">
                      <div class="lighting-status-item" *ngFor="let status of interiorLightingModes">
                        <img class="status-icon" [src]="status.iconPath" alt="{{ status.label }} Icon" />
                        <span class="lighting-value">{{ status.label | translate }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- Labels -->
                  <div *ngIf="systemLabels[activeSubTab] && (currentView === TcddDialogView.TRAIN_OVERVIEW || currentView === TcddDialogView.WAGON_DETAIL)"
                       class="status-labels">
                    <ng-container *ngFor="let item of systemLabels[activeSubTab]">
                      <label class="status-item">
                        <span class="status-indicator" [ngStyle]="{'background-color': item.color}"></span>
                        <span class="status-text">{{ item.label | translate }}</span>
                      </label>
                    </ng-container>
                  </div>
                </div>
              </div>

              <!-- Tab Info Content Container -->
              <div *ngIf="isDataLoaded && (leftGroups?.length > 0 || rightGroups?.length > 0)" class="tab-info-container">
                <div class="row">
                  <!-- Loop over two columns: leftGroups and rightGroups -->
                  <ng-container *ngFor="let groupColumns of [leftGroups, rightGroups]; let columnIndex = index">
                    <div class="col-md-6">
                      <ng-container *ngFor="let group of groupColumns; let groupIndex = index">
                        <div *ngIf="group.visibility">
                          <!-- Group Info Section -->
                          <ng-container [ngSwitch]="getGroupTemplate(group)">
                            <!-- Coupling Main Info -->
                            <ng-container *ngSwitchCase="'coupling'">
                              <ng-container *ngTemplateOutlet="matrixHeaderTemplate; context: { groupTitle: group.title, headers: couplingHeaders }"></ng-container>
                              <ng-container *ngTemplateOutlet="defaultTemplate; context: { group: group, columnIndex: columnIndex, groupIndex: groupIndex }"></ng-container>
                            </ng-container>

                            <!-- Matrix Sub Info -->
                            <ng-container *ngSwitchCase="'matrixSub'">
                              <ng-container *ngTemplateOutlet="matrixHeaderTemplate; context: { groupTitle: group.title, headers: group.matrix }"></ng-container>
                              <ng-container *ngTemplateOutlet="matrixSubInfoTemplate; context: { group: group, columnIndex: columnIndex, groupIndex: groupIndex }"></ng-container>
                            </ng-container>

                            <!-- Default -->
                            <ng-container *ngSwitchDefault>
                              <div style="width: 100%;">
                                <label class="column-info title underline-label">
                                  {{ group.title | translate }}:&nbsp;
                                </label>
                              </div>
                              <ng-container *ngTemplateOutlet="defaultTemplate; context: { group: group, columnIndex: columnIndex, groupIndex: groupIndex }"></ng-container>
                            </ng-container>
                          </ng-container>

                          <div *ngIf="groupIndex !== groupColumns.length - 1" class="spacer"></div>
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </nb-tab>
        </nb-tabset>
      </nb-tab>
    </nb-tabset>
  </div>

  <div dialog-card-footer class="dialog-footer">
    <div dialog-card-footer class="footer-left">
      <div>
        <label class="column-info title">{{ 'coordinate' | translate }}:&nbsp;</label>
        <label class="column-info content">{{ location }}</label>
      </div>
      <div>
        <label class="column-info title">{{ 'instantaneousSpeed' | translate }}:&nbsp;</label>
        <label class="column-info content">{{ speed }}{{ 'unit.km/h' | translate }}</label>
      </div>
    </div>
    <div class="footer-right-container">
      <div *ngIf="activeSignalStatus" dialog-card-footer class="footer-right">
        <div>
          <label *ngIf="isCoupling" class="column-info title" style="margin-right: 10px">{{ 'primaryTrain' | translate }}:&nbsp;</label>
          <label style="font-style: italic;" class="column-info signal-info">{{ activeSignalStatus.connectionTypeName }}&nbsp;</label>
          <label>
            <img src="{{ activeSignalStatus.signalQualityIcon }}" alt="Signal quality indicator icon">
          </label>
          <label class="column-info signal-info">&nbsp;{{ activeSignalStatus.signalQuality | translate }}</label>
        </div>
        <div>
          <label class="column-info title">{{ 'lastUpdatedTime' | translate }}:&nbsp;</label>
          <label class="column-info content">{{ activeSignalStatus.lastUpdateTime }}</label>
        </div>
      </div>
      <div *ngIf="isCoupling && passiveSignalStatus" dialog-card-footer class="footer-right">
        <div>
          <label class="column-info title" style="margin-right: 10px">{{ 'secondaryTrain' | translate }}:&nbsp;</label>
          <label style="font-style: italic;" class="column-info signal-info">{{ passiveSignalStatus.connectionTypeName }}&nbsp;</label>
          <label>
            <img src="{{ passiveSignalStatus.signalQualityIcon }}" alt="Signal quality indicator icon">
          </label>
          <label class="column-info signal-info">&nbsp;{{ passiveSignalStatus.signalQuality | translate }}</label>
        </div>
        <div>
          <label class="column-info title">{{ 'lastUpdatedTime' | translate }}:&nbsp;</label>
          <label class="column-info content">{{ passiveSignalStatus.lastUpdateTime }}</label>
        </div>
      </div>
    </div>
  </div>
</closeable-dialog>

<!-- Value Render Template -->
<ng-template #renderValue let-value="value" let-info="info">
  <!-- If info.visualElement is defined, show icon, badge, svg or text-->
  <ng-container *ngIf="info.visualElement; else showPlainValue">
    <ng-container [ngSwitch]="determineVisualElementType(info.visualElement)">
      <!-- Badge -->
      <ng-container *ngSwitchCase="'badge'">
        <ng-container *ngIf="determineBadge(info.visualElement, info.visualElementTrigger, value) as badgeObj">
          <div class="badge train-badge-common-style train-badge-style" [ngClass]="'train-badge-' + badgeObj.badge">
            <ng-container *ngIf="badgeObj.icon">
              <img [src]="'assets/images/train/' + badgeObj.icon" alt="{{ badgeObj.badge }} icon">
            </ng-container>
            {{ ('train-badge-' + badgeObj.badge) | translate }}
          </div>
        </ng-container>
      </ng-container>
      <!-- SVG -->
      <ng-container *ngSwitchCase="'svg'">
        <img style="width:clamp(18px, 1.25vw, 28px); height: clamp(18px, 1.25vw, 28px);"
             [src]="'assets/images/train/' + determineSvg(info.visualElement, info.visualElementTrigger, value)" alt="SVG">
      </ng-container>
      <!-- Text -->
      <ng-container *ngSwitchCase="'text'">
        <label [ngStyle]="{ 'color': getTextColor(info.name, value)}" class="column-info content">{{ determineText(info.visualElement, info.visualElementTrigger, value) | translate }}</label>
      </ng-container>
      <!-- Icon or default-->
      <ng-container *ngSwitchDefault>
        <i [ngClass]="determineIcon(info.visualElement, info.visualElementTrigger, value)"></i>
      </ng-container>
    </ng-container>
  </ng-container>
  <!-- If info.visualElement is not defined, show the value and unit -->
  <ng-template #showPlainValue>
    <label [ngStyle]="{ 'color': getTextColor(info.name, value) }" class="column-info content">
      {{ value != null
        ? (value + ' ' + (info.unit | translate))
        : ('N/A' | translate)
      }}
    </label>
  </ng-template>
</ng-template>

<!-- Matrix Header Template -->
<ng-template #matrixHeaderTemplate let-groupTitle="groupTitle" let-headers="headers">
  <div class="info-row">
    <div class="info-cell info-header">
      <label class="column-info title underline-label">
        {{ groupTitle | translate }}:&nbsp;
      </label>
    </div>

    <!-- Create header cells for each matrix item -->
    <ng-container *ngFor="let header of headers">
      <div class="info-cell info-value">
        <label class="column-info matrix-title underline-label">
          {{ header.name | translate }}
        </label>
      </div>
    </ng-container>
  </div>
</ng-template>

<!-- Matrix Sub Info Template -->
<ng-template #matrixSubInfoTemplate let-group="group" let-columnIndex="columnIndex" let-groupIndex="groupIndex">
  <ng-container *ngFor="let sectionIndex of getSectionIndices(group)">
    <div *ngIf="isMatrixRowVisible(group, columnIndex, groupIndex, sectionIndex)" class="info-row">
      <div class="info-cell info-header">
        <label class="column-info content" style="padding-left: 5px;">{{ group.infoList[sectionIndex * group.matrix.length]?.name | translate }}:&nbsp;</label>
      </div>

      <ng-container *ngFor="let info of group.infoList.slice(sectionIndex * group.matrix.length, (sectionIndex + 1) * group.matrix.length); let infoIndex = index">
        <div class="info-cell info-value">
          <ng-container *ngIf="getDynamicValues(calculateGroupIndex(columnIndex, groupIndex), sectionIndex * group.matrix.length + infoIndex) as values">
            <ng-container *ngTemplateOutlet="renderValue; context: { value: values.primaryValue, info: info }"></ng-container>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-template>

<!-- Default Template -->
<ng-template #defaultTemplate let-group="group" let-columnIndex="columnIndex" let-groupIndex="groupIndex">
  <ng-container *ngFor="let info of group?.infoList; let infoIndex = index">
    <ng-container *ngIf="getDynamicValues(calculateGroupIndex(columnIndex, groupIndex), infoIndex) as values">
      <div *ngIf="(isSingleRowVisible(columnIndex, values, info.visualElementTrigger) && (info.visibility ?? true))" class="info-row">
        <div class="info-cell info-header">
          <label class="column-info content" style="padding-left: 5px;">{{ info.name | translate }}:&nbsp;</label>
        </div>

        <div class="info-cell info-value">
          <ng-container *ngTemplateOutlet="renderValue; context: { value: values.primaryValue, info: info }"></ng-container>
        </div>

        <div *ngIf="values.secondaryValue" class="info-cell info-value">
          <ng-container *ngTemplateOutlet="renderValue; context: { value: values.secondaryValue, info: info }"></ng-container>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #listTemplate>
  <div class="table-wrap">
    <div class="scroll-x">
      <table>
        <thead>
        <tr>
          <th>{{ 'level' | translate }}</th>
          <th>{{ 'anomalySignal' | translate }}</th>
          <th>{{ 'setNo' | translate }}</th>
          <th>{{ 'vehicleName' | translate }}</th>
          <th>{{ 'subsystem' | translate }}</th>
          <th>{{ 'portName' | translate }}</th>
          <th>{{ 'anomalyCount' | translate }}</th>
          <th>{{ 'firstAnomalyDatetime' | translate }}</th>
          <th>{{ 'lastAnomalyDatetime' | translate }}</th>
        </tr>
        </thead>
        <tbody *ngIf="pmOutputMap && pmOutputMap.length > 0; else noData">
        <tr *ngFor="let item of pmOutputMap">
          <td>
            <span class="dot" [ngClass]="getLevelClass(item)"></span>
          </td>
          <td>{{ item.anomalySignal }}</td>
          <td>{{ item.setNo }}</td>
          <td>{{ item.vehicleName }}</td>
          <td>{{ item.subsystem }}</td>
          <td>{{ item.portName }}</td>
          <td>{{ item.anomalyCount }}</td>
          <td>{{ item.firstAnomalyDatetime | date:'dd.MM.yyyy HH:mm' }}</td>
          <td>{{ item.lastAnomalyDatetime | date:'dd.MM.yyyy HH:mm' }}</td>
        </tr>
        </tbody>
      </table>

      <ng-template #noData>
        <tr class="no-data-row">
          <td colspan="9">
            {{ 'noDataAvailable' | translate }}
          </td>
        </tr>
      </ng-template>
    </div>
  </div>
</ng-template>
